<template>
  <div class="box9">
    <pageTitle
      title="技术应用&nbsp;&nbsp;夯实理论"
      text="社会主流热点随时更新，学完胜任企业工作"
    />

    <div class="demo">
      <div class="demo-top">
        <div class="title">40+ 解决方案</div>
        <img src="../../../assets/coursePage/ai/box9/icon1.png" alt />
      </div>
      <p v-for="i in list1" :key="i">
        <span></span>
        {{ i }}
      </p>
    </div>

    <div class="demo demo2">
      <div class="demo-top">
        <div class="title">10+ 技术栈</div>
        <img src="../../../assets/coursePage/ai/box9/icon2.png" alt />
      </div>
      <p v-for="j in list2" :key="j">
        <span></span>
        {{ j }}
      </p>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list1: [
        "模型训练流水线(Model ML FLow)",
        "模型并行预测服务(Model Parallel Predict Serving)",
        "模型热更新微服务(Tensorflow Serving)",
        "分布式模型训练(Distributed Model Train)",
        "自动参数调优(Automatic Parameter Tuning)",
        "Fasttext模型全面解析应用",
        "Transformer迁移学习深入实践",
        "ResNet主干视觉网络剖析",
        "强化学习与对抗网络解读",
        "大型模型压缩与知识蒸馏探索",
        "对抗网络系列算法论文复现",
      ],
      list2: [
        "建立交通流系统状态和观测状态的解决方案",
        "图像去畸变的解决方案",
        "实时采集摄像头人脸视频的解决方案",
        "动态图像人脸定位的解决方案",
        "医学影像格式转换的解决方案",
        "可疑病灶区域标记及预诊断的解决方案",
        "基于多模型级联学习的场景识别解决方案",
        "基于端到端算法的目标检测解决方案",
        "模型训练中数据增强的解决方案",
        "基于Label Image的图像标注的解决方案",
        "知识图谱的双画像关系存储解决方案",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.box9 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box9/bg.png") no-repeat;
  background-size: cover;

  .demo {
    margin: 0 auto;
    margin-top: 40px;
    padding: 40px 40px 0px 48px;

    width: 686px;
    height: 854px;
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.3) 0%,
        rgba(243, 250, 255, 0.3) 100%
      )
      linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 4px 8px 30px 0px rgba(0, 0, 0, 0.05),
      inset 2px 2px 4px 0px #ffffff;
    border-radius: 12px 100px 12px 12px;
    backdrop-filter: blur(6px);
    box-sizing: border-box;

    .demo-top {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .title {
        position: relative;
        margin-bottom: 38px;
        font-size: 30px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 50px;
        background: linear-gradient(270deg, #1fd7cd 0%, #65adff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        &::after {
          position: absolute;
          left: 0px;
          bottom: -12px;
          content: "";
          width: 80px;
          height: 4px;
          background: linear-gradient(270deg, #1fd7cd 0%, #65adff 100%);
          border-radius: 2px;
        }
      }
      img {
        width: 72px;
        height: 72px;
      }
    }

    p {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        background: #ffffff;
        border-radius: 50%;
        border: 5px solid #d0f2ff;
        box-sizing: border-box;
      }
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }

  .demo2 {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(243, 250, 255, 0.3) 100%
    );
    box-shadow: 8px 16px 60px 0px rgba(0, 0, 0, 0.05),
      inset 2px 4px 6px 0px #ffffff;
    border-radius: 12px 100px 12px 12px;
    backdrop-filter: blur(12px);
  }
}
</style>
